/**
 * @fileoverview added by tsickle
 * Generated from: util/deferred.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Create a deferred promise.
 * @template T
 */
var /**
 * Create a deferred promise.
 * @template T
 */
Deferred = /** @class */ (function () {
    function Deferred() {
        var _this = this;
        this.promise = new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        }));
    }
    return Deferred;
}());
/**
 * Create a deferred promise.
 * @template T
 */
export { Deferred };
if (false) {
    /** @type {?} */
    Deferred.prototype.promise;
    /** @type {?} */
    Deferred.prototype.resolve;
    /** @type {?} */
    Deferred.prototype.reject;
}
